<style>
.message-sent {
  @apply bg-gray-300;
}
.message-received {
  @apply bg-blue-200;
}
</style>

<script>
import API from "@local/utils/api"
import { onMount, onDestroy } from "svelte"
import { currentUser } from "@local/store/auth"
import TextArea from "./_TextArea.svelte"
import Button from "./Button.svelte"
import Warning from "./Warning.svelte"
import { sendText } from "@shared/utils/translations"
import { workflowLang } from "@shared/store/workflowKey"
import {
  postQuestionHereText,
  sendToThePractitionerText,
} from "@shared/utils/translations"

export let chat = []
export let wfId = undefined
export let userId = undefined
export let className = ""
export let pollingTime = 0
export let disabled = false

$: disabledChat =
  disabled || (chat.length === 0 && $currentUser.roles?.includes("patient"))

$: disableSent = chat[chat.length - 1]?.authorId === $currentUser.id

let placeholder = $currentUser.roles?.includes("doctor")
  ? postQuestionHereText[$workflowLang]
  : sendToThePractitionerText[$workflowLang]
let newMessage = ""
let intervalId

async function fetchMessages(fromDate) {
  try {
    const searchParams = {
      role: $currentUser.roles,
      ...(fromDate && { fromDate }),
    }

    const response = await API.get(`workflows/${wfId}/messages`, {
      searchParams,
    })

    if (response.ok) {
      const body = await response.json()
      chat = fromDate ? [...chat, ...body] : body
    }
  } catch (error) {
    console.error("Error to load messages:", error)
  }
}

async function sendMessage() {
  if (!newMessage.trim()) return
  try {
    const response = await API.post(`workflows/${wfId}/messages`, {
      searchParams: { role: $currentUser.roles },
      json: { message: newMessage },
    })

    if (response.ok) {
      newMessage = ""
      await fetchMessages()
    }
  } catch (error) {
    console.error("Error to send message:", error)
  }
}

onMount(() => {
  fetchMessages()

  if (pollingTime > 0) {
    intervalId = setInterval(() => {
      const lastMessageDate = chat[chat.length - 1]?.createdAt
      fetchMessages(lastMessageDate)
    }, pollingTime)
  }
})

onDestroy(() => {
  clearInterval(intervalId)
})
</script>

{#if !disabledChat}
  <div class="flex flex-col h-full {className}">
    <div class="flex-1 overflow-y-auto space-y-4 max-h-96">
      {#each chat as content}
        <div class="flex items-start justify-center">
          <div class="max-w-3xl">
            <!-- <p class="pb-2 whitespace-pre-line">{content.firstName}</p> -->
            <p
              class="text-center text-2xl whitespace-pre-line"
              class:font-semibold="{content.authorRole === 'doctor'}"
              class:mb-8="{content.authorRole !== 'doctor'}"
            >
              {content.message}
            </p>
            <!-- <p class="flex justify-end text-sm italic">{content.createdAt}</p> -->
          </div>
        </div>
      {/each}
    </div>

    <div class="flex flex-col mt-12 space-y-6">
      <TextArea
        bind:value="{newMessage}"
        rows="5"
        placeholder="{placeholder}"
        resizable="{true}"
        disabled="{disabled}"
      />
      <!-- <textarea
      bind:value="{newMessage}"
      placeholder="Type your message..."
      rows="3"
      class="resize-none border rounded p-2 w-full focus:outline-none focus:ring focus:border-red-300"
      disabled="{disabled}"></textarea> -->

      <Button
        type="button"
        color="primary"
        filled="{true}"
        label="{sendText[$workflowLang]}"
        on:click="{sendMessage}"
        disabled="{disableSent}"
      />
    </div>
  </div>
{/if}
